import { MenuOption } from '@lexical/react/LexicalTypeaheadMenuPlugin'
import type { EditorUser } from '../../../types'

type IndividualAttendeeMentionOptionArgs = {
    index: number
    email: string
    name: string
    imgUrl: string | null
    id: string
    user: EditorUser
}

export class IndividualAttendeeMentionOption extends MenuOption {
    email: IndividualAttendeeMentionOptionArgs['email']

    name: IndividualAttendeeMentionOptionArgs['name']

    imgUrl: IndividualAttendeeMentionOptionArgs['imgUrl']

    index: IndividualAttendeeMentionOptionArgs['index']

    id: IndividualAttendeeMentionOptionArgs['id']

    user: EditorUser

    constructor({
        index,
        email,
        name,
        imgUrl,
        id,
        user,
    }: IndividualAttendeeMentionOptionArgs) {
        super(email)
        this.index = index
        this.id = id
        this.email = email
        this.name = name
        this.imgUrl = imgUrl
        this.user = user
    }
}

export class AllMeetingAttendeesMentionOption extends MenuOption {
    constructor() {
        super('all-meeting-attendees')
    }
}

type MetionOption =
    | AllMeetingAttendeesMentionOption
    | IndividualAttendeeMentionOption

export { type MetionOption }
